import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=2e18603b&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=ts&"
export * from "./BaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=2e18603b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18603b",
  null
  
)

export default component.exports